import { createAPIModule } from 'utility/redux/apiModuleHelpers';
import { createSelector } from 'reselect';
import { List as ImmutableList } from 'immutable';

const getStateSlice = (state) => state.api.network.dns.zone.history.list;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_ZONE_HISTORY_LIST',
	method: 'POST',
	url: '/network/dns/zone/history/list.json',
});

const selectors = {
	items: createSelector(defaultSelectors.getStateSlice, (slice) =>
		slice.getIn(['data', 'items'], ImmutableList()),
	),
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
